import { render } from "./HistoryItemList.vue?vue&type=template&id=5c7a9285"
import script from "./HistoryItemList.vue?vue&type=script&lang=js"
export * from "./HistoryItemList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/HistoryItemList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c7a9285"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c7a9285', __exports__)) {
    console.log('reload')
    api.reload('5c7a9285', __exports__)
  }
  
  module.hot.accept("./HistoryItemList.vue?vue&type=template&id=5c7a9285", () => {
    console.log('re-render')
    api.rerender('5c7a9285', render)
  })

}


export default __exports__